import { CSSProperties, ReactNode } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

type TabsSwitcherProps = {
  tabs: {
    label: ReactNode;
    value: string;
    icon?: string;
  }[];
  cols?: number;
  active: string;
  onChange: (value: string) => void;
  className?: string;
};

export default function TabsSwitcher ({
  tabs,
  active,
  onChange,
  cols = 2,
  className,
}: TabsSwitcherProps) {
  const activeIndex = tabs.findIndex((tab) => tab.value === active)

  return (
    <div
      className={cn(styles.tabs, className)}
      style={
        {
          '--cols': cols,
        } as CSSProperties
      }
    >
      <div
        className={styles.tabs__slider}
        style={{
          transform: `translateX(${activeIndex * 100}%)`,
        }}
      />
      {tabs.map((tab, i) => (
        <div
          key={`${tab.value}-${i}`}
          className={styles.tabs__tab}
          onClick={() => onChange(tab.value)}
        >
          {tab.icon && (
            <img src={`/icons/${tab.icon}.svg`} alt="icon" loading="lazy" />
          )}
          {tab.label}
        </div>
      ))}
    </div>
  )
}
